import { getTableColumns } from 'helpers';


const RemainingColumns =  [
['stratumName', 'string', 'Arm', 'left', true],
['description', 'string', 'Description', 'left', true],
['status', 'string', 'Status', 'left', true],
['statusDate', 'string', 'Status Date', 'left', true],
['statusReason', 'string', 'Reason', 'left', true],
['accrualTarget', 'string', 'Accrual Target', 'left', true],
['currentAccrual', 'string', 'Current Accrual', 'left', true]
]
const ArmsGridCols = [
...getTableColumns(RemainingColumns)
];

export default ArmsGridCols;
  